<template>
    <div>
        <topnav @tosearch="tosearch" :keywords="keyword" :toptype="toptype" :isSearch="path"></topnav>
        <div class="" style="min-height: 600px;">
            <div class="marginauto conwidth topall" >
                <div class="flex justify-start align-center " :class="sortid ? 'margth' :''">
                    <div class="" style="color: #959595;font-size: 16px;margin-right: 15px;line-height: 37px;width: 100px;">服务类型:</div>
                    <div class="flex justify-start align-center flex-wrap">
                        <div class="topone pointer" v-for="(item,index) in sortlist" :key="index" @click="tochange(item.id,index)" :class="item.checked ? 'active':''">{{item.name}}</div>
                    </div>
                </div>
                <div v-if="sortid" class="flex justify-start align-center">
                    <div class="" style="color: #959595;font-size: 16px;margin-right: 15px;line-height: 37px;width: 100px;">项目类型:</div>
                    <div class="flex justify-start align-center flex-wrap">
                        <div class="topone pointer" v-for="(item,index) in sorttwo" :key="index" @click="tochanges(index)" :class="item.checked ? 'active':''">{{item.name}}</div>
                    </div>
                </div>
            </div>
            <div class="bggray response" style="padding: 40px 0;">
                <div class="marginauto conwidth">
                    <div class="flex justify-start flex-wrap align-center response">
                        <div class="animated slideInLeft " v-for="(item,index) in list" :key="index" @click="todetail(item.id)" >
                            <div class="cone pointer hvr-float">
                                <el-image style="width: 268px;height: 268px;" :src="item.image | addurl" fit="cover"></el-image>
                                <div class="" style="padding: 20px 0;">
                                    <div class="text-cut" style="color: #1a1a1a;font-size: 23px;margin-bottom: 30px;">
                                        {{item.name}}
                                    </div>
                                    <div class="text-cut" style="color: #606060;font-size: 20px;">
                                        {{item.company}}
                                    </div>
                                </div>
                                <div class="flex justify-between align-center">
                                    <div class="dbtn pointer">详情</div>
                                    <div class="dright">{{item.question_number}}人咨询</div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <div v-if="!list.length && !load" class="" style="min-height: 500px">
                        <el-empty description="暂无数据"></el-empty>
                    </div>
                    <div class="text-center" style="margin-top: 40px;">
                        <el-pagination
                            background
                            layout="prev, pager, next"
                            :pager-count="pagerCount"
                            :hide-on-single-page="true"
                            :page-size="pagesize"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :total="totalnum"
                            >
                            </el-pagination>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return{
            toptype: 4,
            pagesize: 8,
            totalnum: 0,
            currentPage: 1,
            pagerCount: 7,
            sorttwo: [],
            sortlist: [],
            sortid: 0,
            sorttwoid: 0,
            list: [],
            load: true,
            keyword: '',
            path: '/technics',
        }
    },
    methods:{
        todetail(id){
            this.$router.push({path: '/techdetail',query:{id: id}})
        },
        tochange(id,index){
            for(let i in this.sortlist){
                if(this.sortlist[i]['checked']){
                    this.sortlist[i]['checked'] = false;
                }
            }
            this.keyword = '';
            this.sortid = this.sortlist[index].id;
            this.sorttwoid = 0;
            this.sortlist[index]['checked'] = true;
            this.getsort(id);
            this.getnewlist();
            this.$forceUpdate();
        },
        tochanges(index){
            for(let i in this.sorttwo){
                if(this.sorttwo[i]['checked']){
                    this.sorttwo[i]['checked'] = false;
                }
            }
            this.sorttwoid = this.sorttwo[index].id;
            this.keyword = '';
            this.sorttwo[index]['checked'] = true;
            this.getnewlist();
            this.$forceUpdate();
        },
        getnewlist(){
            this.list = [];
            this.totalnum = 0;
            this.currentPage = 1;
            this.load = true;
            this.keyword = '';
            this.getlist();
        },
        getsort(cat_id){
            var data = {
                cat_id: cat_id
            }
            this.$api.index.tech_category(data).then(res => {
                
                if(cat_id > 0){
                    if(res.data.length){
                        var sdata = {
                            name: '全部',
                            id: 0
                        }
                        for(let i in res.data){
                            res.data['checked'] = false;
                        }
                        res.data.unshift(sdata)
                        res.data[0]['checked'] = true;
                    }
                    this.sorttwo = res.data;
                }else{
                    if(res.data.length){
                        var sdata = {
                            name: '全部',
                            id: 0
                        }
                        for(let i in res.data){
                            res.data['checked'] = false;
                        }
                        res.data.unshift(sdata)
                        res.data[0]['checked'] = true;
                    }
                    this.sortid = res.data[0].id;
                    this.sortlist = res.data;
                    this.sorttwo = [];
                    // this.getsort(res.data[0].id)
                }
                this.load = false;
                this.$forceUpdate();
            })
        },
        getlist(){
            var data = {
                start: this.currentPage,
                page_size: this.pagesize,
                first_id: this.sortid,
                second_id: this.sorttwoid,
                keyword: this.keyword
            }
            this.$api.index.tech_list(data).then(res => {
                console.log(res,123)
                this.list = res.data;
                this.totalnum = res.count;
                if(res.data.length == 0){
                    this.load = false;
                }
            })
        },
        handleSizeChange(){

        },
        handleCurrentChange(currentPage){
            this.currentPage = currentPage;
            this.list = [];
            this.getlist();
        },
        tosearch(data){
            console.log(data)
            var data = JSON.parse(data);
            this.keyword = data.keyword;
            this.sortid =  0;
            this.sorttwoid =  0;
            this.list = [];
            this.currentPage = 1;
            this.totalnum = 0;
            this.getlist();
        },
    },
    created(){
        this.getsort(0);
        if(this.$route.query.keyword){
            this.keyword = this.$route.query.keyword;
            this.sortid =  0;
            this.sorttwoid =  0;
            this.list = [];
            this.currentPage = 1;
            this.totalnum = 0;
            setTimeout(() => {
                this.getlist();
            }, 300);
        }else{
            setTimeout(() => {
                this.getlist();
            }, 300);
        }
    }
}
</script>
<style scoped>
    .bggray{
        background-color: #eef1fa;
    }
    .topall{
        padding: 45px 0;
        background-color: #fff;
    }
    .topone{
        padding: 8px 18px;font-size: 16px;color: #4e4e4e;
    }
    .active{
        background-color: #ebf8ff;
	    border-radius: 4px;color: #1759d8;
    }
    .cone{
        width: 263px;background-color: #ffffff;
        padding: 25px;margin-bottom: 15px;
        margin-right: 15px;
    }
    .colorone{
        color: #ffa10e;font-size: 20px;
    }
    .colortwo{
        color: #1e1e1e;font-size: 18px;
        width: 80px;
    }
    .csbtn{
        height: 48px;width: 100%;
        line-height: 48px;
        background-image: linear-gradient(86deg, 
        #005aeb 0%, 
        #00a0fd 100%);
        border-radius: 3px;font-size: 18px;color: #fff;
    }
    .dbtn{
        width: 120px;color: #fff;text-align: center;
        height: 35px;line-height: 35px;
        background-color: #ffab18;
        border-radius: 4px;font-size: 18px;
    }
    .dright{
        color: #a7a7a7;font-size: 18px;
    }
    .margth{
        margin-bottom: 35px;
    }
</style>


// WEBPACK FOOTER //
// technics.vue?e1a0b226